<template>
    <b-modal
        :id="modalId"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        size="xl"
        centered
        @show="openModalHandler"
        @hidden="hideModal"
    >
        <template slot="modal-title">
            {{ modalTitle }}
        </template>
        <div class="row col-12 ml-0 pt-3">
            <textarea
                v-model="notes"
                class=" form-control rounded-0"
                rows="7"
                placeholder="Write your notes here.."
            >
            </textarea>
        </div>

        <template #modal-footer>
            <div
                class="col-12 d-flex justify-content-between pr-4 pl-4 pt-2 pb-2"
            >
                <button
                    class="btn pl-5 pr-5 btn-success waves-effect waves-light"
                    @click="submitEditingNotes"
                >
                    Save
                </button>
                <button
                    class="btn pl-5 pr-5 btn-danger waves-effect waves-light"
                    @click="hideModal"
                >
                    Cancel
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        editingNote: {
            type: String,
            required: false,
            default: null
        },
        calculationsRequestId: {
            type: String,
            required: false,
            default: ''
        },
        modalId: {
            type: String,
            required: false,
            default: 'mediaChooserModal'
        }
    },

    data() {
        return {
            notes: '',
            modalTitle: 'Edit notes'
        };
    },

    methods: {
        ...mapActions({
            updateNotes: 'calculationsRequests/updateNotes'
        }),

        hideModal() {
            this.$bvModal.hide(this.modalId);
            this.$emit('hide');
            this.notes = '';
        },

        async openModalHandler() {
            await this.$nextTick();

            if (this.editingNote) {
                this.notes = this.editingNote;
            }
        },

        async submitEditingNotes() {
            try {
                const notes = await this.updateNotes({
                    id: this.calculationsRequestId,
                    notes: this.notes
                });

                this.$emit('updated', notes);

                const message = 'Notes has been updated!';

                this.$bvToast.toast(message, {
                    title: 'Updated!',
                    variant: 'success',
                    solid: true
                });

                this.hideModal();
            } catch (error) {
                console.error(error);

                const message =
                    error.response &&
                    error.response.data &&
                    error.response.data.error
                        ? error.response.data.error
                        : 'Something went wrong!';

                this.$bvToast.toast(message, {
                    title: 'Error!',
                    variant: 'danger',
                    solid: true
                });
            }
        }
    }
};
</script>

<style>
.modal-body {
    padding: 0;
}
</style>
